var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.endpoints.length)?_c('div',[_c('div',{attrs:{"fx":"","fxSB":"","pb-2":""}},[_c('div'),_c('CreateNewButton',{attrs:{"disabled":!_vm.isMenuEnabled,"onClick":_vm.redirectToAddAnotherPrivateLink}})],1),_c('JFGrid',_vm._b({attrs:{"w-100":""}},'JFGrid',_vm.gridProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }